import React from "react";

import InputBox from "../../../../../components/input-box/input-box";
import AddressServices from "../../../../../services/AddressServices";
import { PostalCodeProps } from "./postal-code-types";

const PostalCode = ({ valid, value, disabled, setLoading, onChange }: PostalCodeProps) => {
  const getPostalCodes = async (input: string) => {
    const resPostalCodes = await AddressServices.getPostalCodes({
      loader: true,
      setLoading: setLoading,
      params: [`input=${input}`, `provinceCode=*`, `cityCode=*`, `street=0`],
    });

    return resPostalCodes.length > 0;
  };

  const handleOnChange = async (value: string) => {
    if (value.length <= 5) {
      valid.postalCode.errorCode = "";

      if (value.length === 5) {
        valid.postalCode.validated = await getPostalCodes(value);
        if (!valid.postalCode.validated) {
          valid.postalCode.errorCode = "invalid-postal-code";
        }
      } else {
        if (valid.postalCode.validated) valid.postalCode.errorCode = "invalid-postal-code";
        valid.postalCode.validated = false;
      }
      onChange({ value, valid });
    } else {
      if (valid.postalCode) {
        valid.postalCode.validated = false;
        onChange({ valid });
      }
    }
  };

  const handleOnBlur = (value: string) => {
    if (value.length > 0 && value.length < 5) {
      valid.postalCode.errorCode = "invalid-postal-code";
      valid.postalCode.validated = false;
    }
    onChange({ valid });
  };

  return (
    <div className="inputBox">
      <InputBox
        errorCode={valid.postalCode.errorCode}
        maxLength={5}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        placeholder="Código Postal"
        required
        type="number"
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default PostalCode;
